






















































































import { CvModule } from '@app/componentlib/src/store/modules/cvdata'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import BaseIcon from '../../components/BaseIcon.vue'
import PDFFile from '../../components/icons/PDFFile.vue'
import WordFile from '../../components/icons/WordFile.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Section } from '../CvView.vue'
import ArrowNavigation from '@app/componentlib/src/views/components/ArrowNavigation.vue'
import { ga } from '@app/componentlib/src/application/analytics'

@Component<CvDownload>({
  props: {
    section: Object,
    template: Boolean,
    linkToDocuments: String,
    documentsLinkName: String,
    coverLetterId: Number
  },
  components: {
    ArrowNavigation,
    BaseIcon,
    PDFFile,
    WordFile
  }
})

export default class CvDownload extends Vue {
  /**
   * Props variables
   */
  section: Section | undefined
  pdf: boolean = false
  savedToDocuments: boolean = false
  savedCoverLetterToDocuments: boolean = false
  template: boolean | undefined
  linkToDocuments: string | undefined
  documentsLinkName: string | undefined
  coverLetterId: number | undefined

  /**
   * Component state variables
   */
  selectedFormat = 'Word'
  format = ['Word', 'PDF']

  /**
   * Lifecycle
   */


  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get savingToDocuments (): boolean  {
    if (CvModule.savingToDocuments){
      this.savedToDocuments = true
    }
    return CvModule.savingToDocuments
  }
  get savingCoverLetterToDocuments (): boolean  {
    if (CvModule.savingCoverLetterToDocuments){
      this.savedCoverLetterToDocuments = true
    }
    return CvModule.savingCoverLetterToDocuments
  }

  /**
   * Methods
   */
  changeSection () {
    this.$emit('changeSection', {path:'3', back:true})
  }
  formatChanged () {
    this.selectedFormat === 'PDF' ? this.pdf = true : this.pdf = false
  }

  clearSelection () {
    ga.event({
      action: 'Clear selection',
      category: 'CV Tool',
      label: 'Bottom Download'
    })
    this.$emit('clearSelect')
  }

  downloadCV (isPdf: boolean) {
    this.$emit('download', isPdf !== undefined ? isPdf : this.pdf)
  }

  downloadCoverLetter() {
    this.$emit('downloadCoverLetter')
  }

  saveInDocuments(isPdf: boolean) {
    if(this.savingToDocuments === false) this.$emit('saveInDocuments', isPdf !== undefined ? isPdf : this.pdf)
  }

  saveCoverLetterInDocuments() {
    if(this.savingToDocuments === false) this.$emit('saveCoverLetterInDocuments')
  }
}
